interface TradingViewSymbolInput {
  symbol: string;
  type?: 'STOCK' | 'CRYPTO' | 'ETF' | 'INDEX' | string;
  exchange?: string;
}

export const formatSymbolForTradingViewWidget = (
  ticker: TradingViewSymbolInput | undefined,
  defaultSymbol = '',
): string => {
  if (!ticker?.symbol) return defaultSymbol;

  if (ticker.type === 'CRYPTO') {
    return ticker.symbol.replace('/USD', 'USDT');
  }

  if (ticker.type === 'ETF') {
    return ticker.symbol;
  }

  if (ticker.exchange) {
    return `${ticker.exchange}:${ticker.symbol.replace('/', '.')}`;
  }

  return ticker.symbol;
};
